// src/components/dashboard/CasilleroRegister.js
import React, { useState } from 'react';
import api from '../../utils/Api'; // 👈 usar api en lugar de axios
import CasilleroForm from './CasilleroRegister';
import { Alert } from '@mui/material';

export default function CasilleroRegister() {
  const initialForm = {
    nombre: '',
    correo: '',
    password: '', // 👈 corregido
    cedula: '',
    direccion: '',
    telefono: ''
  };

  const [formData, setFormData] = useState(initialForm);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  const formValid =
    formData.nombre.trim() &&
    formData.correo.trim() &&
    formData.password.trim() && // 👈 corregido
    formData.cedula.trim();

  const onSubmit = async () => {
    try {
      setLoadingCreate(true);
      const res = await api.post('/auth/register', formData);

      if (res.success) {
        setMensaje(`✅ ${res.mensaje}`);
        setFormData(initialForm); // limpiar formulario
      } else {
        setMensaje(`❌ ${res.mensaje}`);
      }
    } catch (err) {
      console.error('Error en registro:', err);
      setMensaje('❌ Error al registrar cliente');
    } finally {
      setLoadingCreate(false);
    }
  };

  return (
    <>
      <CasilleroForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={onSubmit}
        loadingCreate={loadingCreate}
        formValid={formValid}
      />
      {mensaje && (
        <Alert
          severity={mensaje.startsWith('✅') ? 'success' : 'error'}
          sx={{ mt: 2 }}
        >
          {mensaje}
        </Alert>
      )}
    </>
  );
}